/* global Locale, $j */

if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
if(!window.GS.Toolbar.Text) GS.Toolbar.Text={};
GS.Toolbar.Text.Tools=new Class({
    Extends: GS.Toolbar.Tools,
    class_name:'GS.Toolbar.Text.Tools',
    options:{
        'wrapper': null,
        'class':'submenu full',
        'lexico':{'f':'to Front','b':'To Back'},
        'toolbar':null,
        'font-sizes' : [6,8,9,10,11,12,14,18,24,30,36,48,60,72,85,100,125,150,175,200,250,300],
        'fonts':[
            {'value':'AmericanTypewriter-Bold','text' : 'American Typewriter Bold', 'shift':'0.4em'},
            {'value':'AracneUltraCondensedRegular','text' : 'Aracne UltraCondensed Regular','shift':'0.4em'},
            {'value':'Arial','text':'Arial','shift':'0.4em'},
            {'value':'AustieBostDreamboat','text':'Austie Bost Dreamboat','shift':'0.5em'},
            {'value':'Impact','text':'Impact','shift':'0.27em'},
            {'value':'ImpactLabel','text':'Impact Label','shift':'0.6em'},
            {'value':'ImpactLabelReversed','text':'Impact Label Reversed','shift':'0.6em'},
            {'value':'Lakesight Personal Use Only','text':'Lakesight','shift':'0.3em'},
            {'value':'MrKeningbeck','text':'Mr. Keningbeck', 'shift':'0.5em'},
            {'value':'PassingNotes','text':'Passing Notes','shift':'0.4em'},
            {'value':'Optima-Regular','text':'Optima Regular','shift':'0.45em'},
            {'value':'VintageTypewriter','text':'Vintage Typewriter','shift':'0.6em'}
            
            
            
            /*{'value':'Avenir LT 55 Roman','text':'Avenir'},*/
            /*{'value':'Avenir' , 'text' : 'Avenir Book'},
            
            {'value':'appleberry','text':'AppleBerry'},
            {'value':'Bauer Bodoni','text':'Bauer Bodoni'},
            {'value':'Bickham Script Pro','text':'Bickham Script Pro'},
            {'value':'Bikham Cyr Script','text':'Bikham Cyr Script'},
            {'value':'Birch Std','text':'Birch Std'},
            {'value':'BlairMdITC TT','text':'Blair MDTC TT'},
            {'value':'Brush Script Std','text':'Brush Script'},
            {'value':'Burgues Script','text':'Burgues Script'},
            {'value':'Carpenter Script','text':'Carpenter Script'},
            {'value':'Dr Carbfred','text':'Dr Carbfred'},
            {'value':'Edwardian Scr Alt ITC TT','text':'Edwardian Script'},
            {'value':'Freehand521 BT','text' : 'Freehand'},
            {'value':'Giraffe','text':'Giraffe'},
            {'value':'Helvetica','text':'Helvetica'},
            {'value':'Helvetica Neue LT Std','text':'Helvetica Neue LT'},
            {'value':'Impact','text':'Impact'},
            {'value':'Jellyka BeesAntique Handwriting','text':'Jellyka'},
            {'value':'KidsFirstPrintFont','text': 'Kids First Print'},
            {'value':'KylesHand','text':'Kyles Hand'},
            {'value':'Kozuka Gothic Std','text':'Kozuka'},
            {'value':'Libel Suit','text':'Libel Suit'},
            {'value':'LinotypeZapfino','text':'Lynotype Zapfino'},
            {'value':'MA Sexy','text':'MA Sexy'},
            {'value':'MarkerFeltThin','text':'Marker Felt'},
            {'value':'Minion Pro','text':'Minion Pro'},
            {'value':'Miss Stanfort','text':'Miss Stanfort'},
            {'value':'Mistral','text':'Mistral'},
            {'value':'Mr Canfields','text':'Mr Canfields'},
            {'value':'Mr Lackboughs','text':'Mr Lackboughs'},
            {'value':'MySkinnyJeans','text':'My Skinny Jeans'},
            {'value':'Myriad Pro','text':'Myriad Pro'},*/
            /*{'value':'SC Manipulative Lovers','text':'SC Manipulative Lovers'},*/
            /*{'value':'Seriously','text':'Seriously'},
            {'value':'Skia','text':'Skia'},
            {'value':'Sudestada','text':'Sudestada'},
           /* {'value':'Swiss 721','text':'Swiss 721'},*/
            /*{'value':'Tall Films','text':'Tall Films'},
            {'value':'Times New Roman','text':'Times New Roman'},
            {'value':'TrajanPro-Regular','text':'Trajan Pro'},
            {'value':'WishingOnAStar','text':'Wishing On A Star'},
            {'value':'Zapfino Extra LT Pro','text':'Zapfino'},*/
            
            
            
        ],
        'text-options':{
            'iconsPath':'/images/interface/toolbar/textIcons.png',
            'fullPanel':false,
            /*'buttonList':['bold','italic','underline'],*///,'left','center','right','justify'/*,'fontFamily'*/],
            'buttonList':[],
            'panelClass':'AlkadiaPanelWrapper',
            'debug':1
        }
    },
    controlled:null,
    editors:null,
    initialize:function(conf){
       this.options.lexico=Locale.get('Toolbar.text_tools');
       if(window.GS.FontMap) this.options.fonts = window.GS.FontMap;
       this.parent(conf);
       this.dispatch('exteditor:configure',this.options.fonts,this.options['font-sizes']);
    }
    
});
GS.Toolbar.Text.Tools.prototype.attachToToolbar=function(t){

    var self = this, w = this.smw, type = self.options.type;
    this.toolbar = t;

    t.addEvent('submenu:show', function (t) {

        if (self.smw !== t) {
            self.smw.removeClass('selected');
            if (self.sm)
                self.sm.setStyle('display', 'none');
        }
    });

    this.register('no:selection',function(o,permission){
       //console.debug('Attach to:',o);
       self.controlled=o;
       if(!o) return;
       self.updatePermissions(permission);
    });

    this.register('active:frame', function (o) {
        self.controlled = o;
       // console.debug('ACTIVE FRAME', o);
        if (!o)
            return;
        var p = self.updatePermissions(o ? o.getPermissions() : {});
        if (self.controlled) {
            if(self.controlled.getData().type == "text"){

                self.setFontFamily(self.controlled.getFontType());
                self.setFontSize(self.controlled.getFontSize());
                self.setLineHeight(self.controlled.getLineHeight());
                self.setFontColor(self.controlled.getFontColor());
                self.setTextAlign(self.controlled.getTextAlign());
            }
        }
    });

    this.register('font:syncvalue', function (o) {
        if (self.controlled && self.controlled.getData().type === "text") {
             self.controlled.___preventSave = true;
            self.setFontFamily(self.controlled.getFontType());
            self.setFontSize(self.controlled.getFontSize());
            self.setLineHeight(self.controlled.getLineHeight());
            self.setFontColor(self.controlled.getFontColor());
            self.setTextAlign(self.controlled.getTextAlign());
            window.requestAnimationFrame(function(){
                delete  self.controlled.___preventSave;
            })

        }
    });

    this.register('toolbar:update:permissions', function (o) {
        self.updatePermissions(o ? o.getPermissions() : {});
    });

    this.configureTools();

    if(riot) {
       // console.log('Mount Text Tools');
        riot.mount('alk-fontsize');
        riot.mount('alk-lineheight');
        riot.mount('alk-fontfamily', {'fonts':this.options.fonts});
        //console.warn(JSON.stringify(this.options.fonts));
    }

};

GS.Toolbar.Text.Tools.prototype.updatePermissions = function (p) {

    this.fireEvent('update:permissions', p);
    //console.warn(p);
    this.options.wrapper.style.display = (p && p.text) ? 'block' : 'none';
    if(this.textFontsWrapper) this.textFontsWrapper.style.display = (p && p.text && p.text.fonts) ? 'block' : 'none';
    if(this.textAlignWrapper) this.textAlignWrapper.style.display = (p && p.text && p.text.align) ? 'block' : 'none';
    if(this.textColorWrapper) this.textColorWrapper.style.display = (p && p.text && p.text.color) ? 'block' : 'none';
    return p.text;
};

GS.Toolbar.Text.Tools.prototype.configureTools=function(){
    var type=this.options.type,
        w=this.options.wrapper,
        self=this,
        fontSize, _fontSize, _fontLineHeight, _fontFamily,
        smw, smf, niceEditPanelWrapper, 
        propagate = 0;
    
    w.set('html',this.menuTMPL().substitute(this.options.lexico));



    
    //Configure behaviors and callbacks....
    fontSize=w.getElement('select[name="font-size"]');
    _fontSize=w.querySelector('alk-fontsize');
    _fontLineHeight=w.querySelector('alk-lineheight');
    _fontFamily=w.querySelector('alk-fontfamily');

    
    if(_fontFamily) {
        var _onSetFontFamily = 0;
        this.setFontFamily = function (t) {
            _onSetFontFamily = 1;
            _fontFamily.value = t;
            _onSetFontFamily = 0;
        };
        
        this.addEvent('fonttype:set',function(t){
            this.setFontFamily(t);
        });
        
        _fontFamily.addEventListener('change', function (e) {
            if (!_onSetFontFamily && self.controlled) {
                self.controlled.fireEvent('fontfamily:set', this.value);
                self.dispatch('user:interaction', 1);
                self.smf2.setStyle('display', 'block');
                self.smf.addClass('selected');
            }
        }, false);
        
    }
    
    if(_fontLineHeight) {
        var _onSetLineHeight = 0;
        this.setLineHeight = function (s) {
            if(!s || isNaN(s)) return;
            _onSetLineHeight = 1;
            s = parseFloat(s);
            //console.log('setLineHeight',s);
            _fontLineHeight.value = s + 'pt';
            _onSetLineHeight = 0;
        };



        _fontLineHeight.addEventListener('change', function (e) {
            
            if (!_onSetLineHeight && self.controlled) {
                self.controlled.fireEvent('lineheight:set', this.value + this.unit);
                self.dispatch('user:interaction', 1);
                self.smf2.setStyle('display', 'block');
                self.smf.addClass('selected');
            }
        }, false);
    }

    if(_fontSize) {
        var _onSetFontSize = 0;
        this.setFontSize = function (s) {
            _onSetFontSize = 1;
            s = parseFloat(s);
            _fontSize.value = s;
            _fontSize.fontsize = s;
            _fontLineHeight.fontsize = s;
            _onSetFontSize = 0;
        };



        this.addEvent('fontsize:set', function (s) {
            this.setFontSize(s);
        });

        _fontSize.addEventListener('change', function (e) {
            if (!_onSetFontSize && self.controlled) {
                self.controlled.fireEvent('fontsize:set', this.value + this.unit);
                self.dispatch('user:interaction', 1);
                _fontLineHeight.fontsize = this.value + this.unit;

                //self.toolbar.fireEvent('submenu:show', self.smf);
                self.smf2.setStyle('display', 'block');
                self.smf.addClass('selected');
                //self.smw
            }
        }, false);
    }
    
    //Menu and submenu behaviors...
    smw=this.smw=w.getElement('[data-type="submenu"].text-align-tools');

    this.sm=smw.getElement('ul');
    this.sm.setStyle('display','none');
    this.sm.addEvent('click',function(e){
       e.stop();
       e.preventDefault();
    });
    
    smw.addEvent('click',function(e){
        e.stop();
        var s=(self.sm.getStyle('display')!=='block') ? 'block' : 'none';
        self.sm.setStyle('display',s);
        (s==='block') ? this.addClass('selected') : this.removeClass('selected');
        self.toolbar.fireEvent('submenu:show',this);
        
    });
    
    this.configureFontColorTools(w);
    this.configureTextAlignTools(this.sm);
    
    /*niceEditPanelWrapper = w.getElement('.niceedit-icons');
    this.register('texteditor:attach', function (obj) {
        self.editors.addInstance(obj.ele);
    });

    this.register('texteditor:deactive', function (obj) {
        self.editors.fireEvent('blur', self.editors.selectedInstance, null);
    });*/

    this.options['text-options'].buttons = Locale.get('Toolbar.editor.buttons');
    //this.editors = new GS.TextEditor(this.options['text-options']);
    //this.editors.setPanel(niceEditPanelWrapper);

    switch (type) {
        case 'delete':
            var confirmMsg, onDelete, onKeyDown;
            confirmMsg = this.options.lexico.delete_qst;
            onDelete = function () {
                if (confirm(confirmMsg))
                    self.controlled.fireEvent('delete');
            };
            w.addEvent('click', function (e) {
                if (e)
                    e.stop();
                if (!self.active)
                    return;
                onDelete();
            });
            onKeyDown = function (e) {
                if (self.controlled) {
                    if (!self.active)
                        return;
                    if (e.key === "backspace" || e.key === "delete") {
                        e.preventDefault();
                        e.stopPropagation();
                        onDelete();
                    }
                }
            };
            window.addEvent('keydown', onKeyDown);
            break;
    }

    smf = this.smf = w.getElement('[data-type="submenu"].text-fonts-tools');
    this.textFontsWrapper = this.smf;
    /*this.addEvent('update:permissions', function(p){
        if(!p.text || !p.text.fonts) {
            w.parentNode.style.display = 'none';
        }else{
            w.parentNode.style.display = '';
        }
    });*/

    this.smf2 = smf.getElement('ul');
    this.smf2.setStyle('display', 'none');
    this.smf2.addEvent('click', function (e) {
        e.stop();
        e.preventDefault();

    });
    
    smf.addEvent('click', function (e) {
        e.stop();
        e.preventDefault();

        var s = (self.smf2.getStyle('display') !== 'block') ? 'block' : 'none';
        self.smf2.setStyle('display', s);
        (s === 'block') ? this.addClass('selected') : this.removeClass('selected');
        self.toolbar.fireEvent('submenu:show', this);
    });

    self.toolbar.addEvent('submenu:show', function (e) {
        if (e !== self.smf) {
            self.smf2.setStyle('display', 'none');
            self.smf.removeClass('selected');
        }
        if (e !== self.smw) {
            self.smw.removeClass('selected');
            self.sm.setStyle('display', 'none');
        }
    });
};

GS.Toolbar.Text.Tools.prototype.configureFontColorTools=function(w){
    if(!window.$j) return;
    var self=this,cPreview=w.getElement('.color-placeholder'),
    cpEle=w.getElement('[data-type="text-color"]');

    this.textColorWrapper = cpEle;

    this.addEvent('update:permissions', function(p){
        //console.warn('Update color permission', p, cpEle, !p.text || !p.text.color);
        if(!p.text || !p.text.color) {
            cpEle.style.display = 'none';
        }else{
            cpEle.style.display = '';
        }
    });
    var current='#000000',
        changed = 0,
    cp = $j(cpEle).ColorPicker({  
        color: '#000000',
        flat: false,
        
        onShow: function (colpkr) { 
            changed = 0;
            $j(colpkr).fadeIn(500);  
            return false;  
        },  
        onHide: function (hsb,hex,rgb,el) {  
            $j(el).fadeOut(500);  
            if(self.controlled) {
                self.controlled.fireEvent('font-color:end',rgb);
                self.dispatch('user:interaction',1);
            }
            changed = 0;
            return false;  
        }, 
        onSubmit:function(hsb, hex, rgb, el){
            //console.info('asioidsaoidsa');
        },
        onChange: function (hsb, hex, rgb) {  
            changed = 1;
            cPreview.setStyle('background-color','rgb('+rgb.r+','+rgb.g+','+rgb.b+')');
            if(self.controlled) self.controlled.fireEvent('font-color',rgb);
            return false;
        },
        onBeforeShow: function () {
            $j(this).ColorPickerSetColor(current);
	}
    });
    this.setFontColor = function(c){
            current=c;
            cPreview.setStyle('background-color',c);
    };
    
    this.addEvent('fontcolor:set',function(c){
            current=c;
            cPreview.setStyle('background-color',c);
    });
};

GS.Toolbar.Text.Tools.prototype.configureTextAlignTools=function(sm){
    var c=sm.getElements('[data-uitype="btn"]'),
    type,f,self=this;

    this.textAlignWrapper = sm.parentNode.parentNode;

    this.addEvent('update:permissions', function(p){
        if(!p.text || !p.text.align) {
            sm.parentNode.style.display = 'none';
        }else{
            sm.parentNode.style.display = '';
        }
    });

    var closure=function(btn,type){
        btn.addEvent('click',function(e){
           e.stop();
           if(self.controlled) self.controlled.fireEvent('text:align',type);
           _updateAlign(type);
        });
    },
    _updateAlign = function (a){
        Array.each(c,function(btn,i){
            type=btn.getAttribute("data-type");
            if(type === a){
                btn.classList.add('selected');
            }else{
                btn.classList.remove('selected');
            }
        });
    };
    
    this.setTextAlign = function (a){
        _updateAlign(a);
        
    };
    
    Array.each(c,function(btn,i){
        type=btn.getAttribute("data-type");
        closure(btn,type);
        
    });
};


GS.Toolbar.Text.Tools.prototype.menuTMPL=function(){
    var out='<ul>';
    out+='<li class="niceedit-icons" style="display: none;"></li>';
    out+='<li class="text-color" data-type="text-color"  id="toolbar-text-color" data-uitype="colorpicker" title="{tooltip_c}"><div class="color-placeholder"></div></li>';
    
    out+='<li class="text-align-tools" data-type="submenu" title="{tooltip_a}">';
    out+='<ul class="submenu text-align">';
    out+='  <li class="align-left"  data-uitype="btn" data-type="left" title="{tooltip_sx}"></li>';
    out+='  <li class="separator"></li>';
    out+='  <li class="align-center"  data-uitype="btn" data-type="center" title="{tooltip_cx}"></li>';
    out+='  <li class="separator"></li>';
    out+='  <li class="align-right"  data-uitype="btn" data-type="right" title="{tooltip_dx}"></li>';
    out+='  <li class="separator"></li>';
    out+='  <li class="align-justify" data-uitype="btn" data-type="justify" title="{tooltip_jx}"></li>';
    out+='</ul>';
    
    out+='</li>';
    
    out+='<li class="text-fonts-tools" data-type="submenu" title="{tooltip_a}">';
    out+='<ul class="submenu fonts">';
    //out+='  <li>'+this.addFontSizes()+this.addFontList()+'</li>';
    out+='  <li><label>{label_f}</label><alk-fontfamily></alk-fontfamily></li>';
    out+='  <li>';
    out+='      <div class="left"><label>{label_s}</label><alk-fontsize value="50" min="12" max="1000"></alk-fontsize></div>';
    out+='      <div class="right"><label>{label_lh}</label><alk-lineheight fontsize="50" min="0" max="1000"></alk-lineheight></div>';
    out+='  </li>';
    
    out+='</ul>';
    out+='</li>';
    out+='</ul>';
    return out;
};



